"use client";
import { FEATURES, PUBLIC_SETTINGS_KEYS } from "@ea/shared_types/next/ea.enums";
import { useGetPublicSettings } from "@ea/ui/hooks/api/useInternalSettings";
import { createContext } from "react";

export const FeaturesContext = createContext<{ disabledFeatures: FEATURES[] }>({
  disabledFeatures: [],
});

export const FeaturesProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: globalSettings } = useGetPublicSettings();

  const disabledFeaturesSetting = globalSettings?.find(
    (s) => s.id === PUBLIC_SETTINGS_KEYS.DISABLED_FEATURES,
  );

  const disabledFeatures = (disabledFeaturesSetting?.value as FEATURES[]) || [];

  return (
    <FeaturesContext.Provider value={{ disabledFeatures }}>{children}</FeaturesContext.Provider>
  );
};
